import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { globalEnvironment } from "@environments/globalEnvironment";
import { from, Observable, of, switchMap } from "rxjs";

// Liest die Sprachdatei aus window.__seoPreload.langFile, falls sie bereits vorab geladen wurde.
// Fällt auf einen normalen HTTP-Request zurück, wenn kein Prefetch vorliegt oder dieser fehlgeschlagen ist.
export class TranslateLoaderService implements TranslateLoader {
	private readonly suffix = '.json?buildDate=' + new Date(globalEnvironment.buildDate).getTime();

	constructor(private http: HttpClient) {}

	getTranslation(lang: string): Observable<any> {
		const preloaded = (window as any).__seoPreload?.langFile;
		if (preloaded?.lang === lang) {
			return from(preloaded.data as Promise<any>).pipe(
				switchMap((data) => (data ? of(data) : this.fetchFromHttp(lang)))
			);
		}
		return this.fetchFromHttp(lang);
	}

	private fetchFromHttp(lang: string): Observable<any> {
		return this.http.get(`/assets/i18n/${lang}${this.suffix}`);
	}
}
